import React, { useRef } from 'react'
import { Button, Form } from 'react-bootstrap';

const UserMessageSection = ({ messages, newMessage, setNewMessage, handleSend, sending, eventKey }) => {
    const currentUserRoleId = localStorage.getItem('roleId');
    const messagesEndRef = useRef(null);
    return (

        <div id='audience-tab-tabpane-Messaging'>
            {
                messages.length === 0 && (
                    <div className="text-center text-muted mt-5">
                        No messages yet
                    </div>
                )
            }
            {
                messages.map(msg => {
                    const isCurrentUser =
                        String(msg.role_id) === String(currentUserRoleId);

                    return (
                        <div>
                            {eventKey == "Internal-Notes" && msg.is_internal === 1 &&
                                <div
                                    key={msg.id}
                                    className={`d-flex mb-3 ${isCurrentUser
                                        ? 'justify-content-end'
                                        : 'justify-content-start'
                                        }`}
                                >
                                    <div
                                        style={{
                                            maxWidth: '65%',
                                            background: isCurrentUser
                                                ? '#f0f0f0'
                                                : '#f0f0f0',
                                            color: '#000',
                                            padding: '12px 15px',
                                            borderRadius: '12px'
                                        }}
                                    >
                                        <div className="fw-semibold small mb-1">
                                            {`${msg.last_name},${msg.first_name}`}
                                        </div>

                                        <div>{msg.comment}</div>

                                        <div className="text-muted small mt-2">
                                            {new Date(msg.created).toLocaleString()}
                                        </div>
                                    </div>
                                </div>}
                            {eventKey == "Messaging" && msg.is_internal !== 1 &&
                                <div
                                    key={msg.id}
                                    className={`d-flex mb-3 ${isCurrentUser
                                        ? 'justify-content-end'
                                        : 'justify-content-start'
                                        }`}
                                >
                                    <div
                                        style={{
                                            maxWidth: '65%',
                                            background: isCurrentUser
                                                ? '#f0f0f0'
                                                : '#f0f0f0',
                                            color: '#000',
                                            padding: '12px 15px',
                                            borderRadius: '12px'
                                        }}
                                    >
                                        <div className="fw-semibold small mb-1">
                                            {`${msg.last_name},${msg.first_name}`}
                                        </div>

                                        <div>{msg.comment}</div>

                                        <div className="text-muted small mt-2">
                                            {new Date(msg.created).toLocaleString()}
                                        </div>
                                    </div>
                                </div>}
                        </div>
                    );
                })
            }
            <div ref={messagesEndRef} />
        </div>
    )
}

export default UserMessageSection